
import Vue from 'vue';
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {DuplicationDetailsModel} from "@/api-client";

@Component
export default class DuplicationDetails extends Vue {
    @Prop({required: true})
    details!: DuplicationDetailsModel;
}
